export const contactSalesMailData = {
  address: 'sales@anecdotes.ai',
  subject: '',
};
